import { auth } from "services/firebase";
import { platformFetch } from "services/platformFetch";

export async function coverageRequest(path = "", options = {}) {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para analisar o miolo.");
  const response = await platformFetch(`/api/books/coverage${path}`, {
    ...options,
    headers: { ...options.headers, Authorization: `Bearer ${await auth.currentUser.getIdToken()}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Não foi possível consultar a análise de cobertura.");
  }
  return response;
}
